import Vue from 'vue'
import VueResource from 'vue-resource';
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { EventDriver, useRouterForEventDriver } from './utils/EventDriver';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.config.productionTip = false
useRouterForEventDriver(router);

Vue.use(VueResource);
Vue.http.options.root = 'http://localhost:3000';

Vue.http.interceptors.push((request, next) => {
  const token = localStorage.getItem('token');
  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }

  next((response) => {
    if (router.currentRoute.name === 'login') return;
    if (response.status === 403) {
      EventDriver.$emit('closeSession');
    } else if (response.status === 401) {
      EventDriver.$emit('closeSession', router.currentRoute.path);
    }
  });
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
